import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]


export default /*@__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
  buttonType: {
    type: String,
    default: ''
  },
  text: {
    type: String
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['onClick'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: __props.isDisabled,
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick'))),
    class: _normalizeClass(__props.buttonType)
  }, _toDisplayString(__props.text), 11, _hoisted_1))
}
}

})